export const CHOOSE_METHOD_ID = 'choose';
export const INPUT_METHOD_ID = 'input';
